// extracted by mini-css-extract-plugin
module.exports = {"flex":"rarityToggles_flex__lbKqS","container":"rarityToggles_container__8Muoz"};